var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('a',{on:{"click":function($event){return _vm.handleJobClick(_vm.jobId)}}},[_vm._t("default")],2),_c('AffiliatedJobsPreviewJobDialog',{attrs:{"jobId":_vm.previewJobId,"isShow":_vm.isShow},on:{"close":function($event){return _vm.handleDialogClose()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }